import { render, staticRenderFns } from "./hnSsc2.vue?vue&type=template&id=f5231c8c&"
import script from "./hnSsc2.vue?vue&type=script&lang=js&"
export * from "./hnSsc2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports